import React, { useEffect, useState } from 'react';
import { SvgBigSuccessIcon } from '~/src/components/svg-components/big-success-icon';
import type { PopupContentProps } from '~/src/components/common-components/popup-content/popup-content.types';
import * as Styled from './popup-content.styles';

/**
 * Used in Module Federation
 */
const PopupContent = <T, U>({
    title,
    subText,
    mainButtonText,
    subButtonText,
    mainButtonAction,
    subButtonAction,
    titleFontSize,
    subTitleFontSize,
    extraSubText = '',
    mainButtonType,
    subButtonType,
    isShowIcon,
    width,
    minWidth,
    buttonAsLink,
    popupId,
    sendErrorAnalytics,
    resetPopup,
    closeCallback,
    textAlign = 'initial',
    gapContainer,
}: PopupContentProps<T, U>): JSX.Element => {
    const [isLoading, setIsLoading] = useState(false);
    const containerWithSubButtonWidth = 554;
    const containerWithOutSubButtonWidth = 370;
    const getContainerWidth = () => width ||
        (subButtonText ? containerWithSubButtonWidth : containerWithOutSubButtonWidth);

    useEffect(() => {
        setIsLoading(false);
    }, [popupId]);

    useEffect(() => {
        return () => {
            closeCallback && closeCallback();
        };
    }, [closeCallback]);

    async function onClickButtonHandler<M extends T | U>(buttonAction?: M) {
        setIsLoading(true);
        sendErrorAnalytics && subButtonText && sendErrorAnalytics(subButtonText);
        if (buttonAction && typeof buttonAction === 'function') {
            if (buttonAsLink) {
                buttonAction();
                setIsLoading(false);
            } else {
                await buttonAction();
            }
        } else {
            resetPopup();
        }
    }

    return (
        <Styled.PopupContainer width={getContainerWidth()} minWidth={minWidth} gapContainer={gapContainer}>
            <Styled.TextContainer>
                {isShowIcon && <SvgBigSuccessIcon />}
                {title && (
                    <Styled.Title textAlign={textAlign} fontSize={titleFontSize}>
                        {title}
                    </Styled.Title>
                )}
                {subText && (
                    <Styled.SubText textAlign={textAlign} fontSize={subTitleFontSize}>
                        {extraSubText}
                        {subText}
                    </Styled.SubText>
                )}
            </Styled.TextContainer>
            <Styled.ButtonWrapper>
                {mainButtonText && (
                    <Styled.Button onClick={() => onClickButtonHandler(mainButtonAction)} typeVisual={mainButtonType}>
                        {mainButtonText}
                    </Styled.Button>
                )}
                {subButtonText && (
                    <Styled.Button
                        onClick={() => onClickButtonHandler(subButtonAction)}
                        isLoading={isLoading}
                        typeVisual={subButtonType}
                    >
                        {subButtonText}
                    </Styled.Button>
                )}
            </Styled.ButtonWrapper>
        </Styled.PopupContainer>
    );
};

export default PopupContent;

// @TODO Добавить Loader между переходами страниц
